import React, { FC, useState, useEffect } from "react";
import { RouterParamType } from "@/model/navModel";
import { BaseFormBox } from "./BaseFormBox";
import { TableBoxMethod } from "./TableBoxMethod";
import { Form } from "@/components/YhFormBox";
import { IForm, IYhFormRef } from "@/components/YhFormBox/Types";
import { TransportFormBox } from "./TransportFormBox";
import { TableBoxAdded } from "./TableBoxAdded";
import { useOfferDetailModel } from "../offerDetailModel";
import { IOfferDetail } from "../../../offerTypes";


export const BaseDetail: FC<RouterParamType> = ({ formRef, ...detailsInfo }) => {

    const { editFormVal, addFormVal, updateFormVal, clauseChange, isDisabeld } = useOfferDetailModel();
    const formVal = detailsInfo.mode === "edit" ? editFormVal : addFormVal;

    //表单change
    const onChange = (changedValues: { [key: string]: any }, values: IOfferDetail) => {
        let contractAmount: number = 0;
        // 贸易条款change
        if ("clause" in changedValues) {
            // debugger;
            contractAmount = clauseChange(detailsInfo.mode, changedValues.clause)
        }
        updateFormVal(detailsInfo.mode, contractAmount ? { ...changedValues, contractAmount } : changedValues);
    }


    const fromConfig: IForm = {
        formRef: formRef as React.MutableRefObject<IYhFormRef<any>>,
        labelCol: { span: 8 },
        labelAlign: "right",
        onChange,
        formValues: formVal,
        disabled: isDisabeld(detailsInfo.mode)
    }

    return (
        <Form {...fromConfig}>
            <BaseFormBox {...detailsInfo} />
            <TableBoxMethod {...detailsInfo} />
            <TransportFormBox {...detailsInfo} />
            <TableBoxAdded {...detailsInfo} />
        </Form>
    )
}